import i18n from 'locales/i18n';

export const companyTranslationsMap = (company: string | null) => {
  if (company === null) {
    return i18n.t('adminUsers.li3ib');
  }

  return company;
};
